import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ServicerProvider } from './servicer';

import { ApiResponse } from './models/api-response';
import { GenericList } from './models/generic-list';
import { MaintOption } from './models/maint-option';

const BASE_URL = '/v2/system/maint/options';

/**
 * [システム] [メンテナンス] システムオプション のプロバイダー.
 */
@Injectable()
export class SystemMaintOptionsServiceProvider {

  constructor(
    private servicer: ServicerProvider
  ) { }

  /**
   * システムオプション取得処理.
   * 
   * @returns Observable<GenericList<MaintOption>>
   */
  get(): Observable<GenericList<MaintOption>>{
    return this.servicer.get<GenericList<MaintOption>>(BASE_URL);
  }

  /**
   * システムオプション保存処理.
   *
   * @param data 入力データ
   * @returns Observable<ApiResponse>
   */
  post(data: MaintOption[]): Observable<ApiResponse> {
    return this.servicer.postApi<MaintOption[], ApiResponse>(BASE_URL, data);
  }

}



// WEBPACK FOOTER //
// ./src/providers/servicer/system-maint-options-service.ts